import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const HelpIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M12.3 8A2 2 0 0 0 10 9.3a1 1 0 1 1-1.9-.6A4 4 0 0 1 16 10c0 1.5-1.1 2.5-2 3a8 8 0 0 1-1.6 1 1 1 0 0 1-.7-2 3.9 3.9 0 0 0 .4-.1l.9-.5c.7-.4 1-1 1-1.4a2 2 0 0 0-1.6-2Zm-.3 8a1 1 0 1 0 0 2 1 1 0 1 0 0-2Z" />
    <path
      fillRule="evenodd"
      d="M1 12a11 11 0 1 1 22 0 11 11 0 0 1-22 0Zm11-9a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default HelpIcon;
